<template>
    <div ref="container" class="container d-flex align-items-end flex-column h-100">
        <div class="w-100">

            <header class="pt-3 text-center">
                <h1 class='h2 pb-3'>{{ $t('translations.hello')}} {{formatName($root.user)}}</h1>            
                <unread-threads />
                <div v-if='showServiceMessage' class="m-3 mt-2 p-3 card border-0 shadow-sm"><p style="white-space: break-spaces;">{{$root.provider.service_message}}</p></div>
                <appointments v-if='appointmentsEnabled()' />
            </header>

            <div>

                <router-link v-if='tBrandSetting("conf_show_new_request") && (isServiceAvailable() || (isOohUnavailable() && outOfHoursCustomActions().length))' :to='{name: "accessType", params: {action: "form"}}' tag="button" class="card-button w-100 mb-2" title="Create a new request">
                    <div class="card-icon">
                        <img src="/img/egl/messaging-standard3.svg" alt="">
                    </div>
                    <div>
                        <h2>{{ autobrand('translations.new_request')}}</h2>
                        <p><small>{{ autobrand('translations.create_new_request')}}</small></p>
                    </div>
                </router-link>

                <router-link v-if='tBrandSetting("conf_view_past_requests")' :to='$root.isLoggedIn() ? {name: "threadList"} : {name: "loginType"}' tag="button" class="card-button w-100 mb-2" title="View all previous requests">
                    <div class="card-icon">
                        <!-- <span class="count">{{unreadThreads.length}}</span> -->
                        <img src="/img/egl/icon-prev-request.svg" alt="">
                    </div>
                    <div>
                        <h2>{{ autobrand('translations.view_past_requests')}}</h2>
                        <p><small>{{ autobrand('translations.view_all_prev_requests')}}</small></p>
                    </div>
                </router-link>

                <router-link v-if='tBrandSetting("conf_edit_my_details")' :to='{name: "ProfileEdit"}' tag="button" class="card-button w-100 mb-2" title="Edit my details">
                    <div class="card-icon">
                        <img src="/img/egl/icon-edit.svg" alt="">
                    </div>
                    <div>
                        <h2>{{ $t('translations.edit_my_details')}}</h2>
                        <!-- <p><small></small></p> -->
                    </div>
                </router-link>

                <router-link v-if='tBrandSetting("conf_proxy")' :to='{name: "SelectCaree"}' tag="button" class="card-button w-100 mb-2" title="Patients I care for">
                    <div class="card-icon">
                        <!-- <span class="count">{{unreadThreads.length}}</span> -->
                        <img src="/img/egl/icon-care.svg" alt="">
                    </div>
                    <div>
                        <h2>{{ autobrand('translations.people_i_care_for') }}</h2>
                        <!-- <p><small></small></p> -->
                    </div>
                </router-link>
                
                <!-- <router-link :to='{name: "ProfileEdit"}' tag="button" class="btn btn-round btn-block btn-primary">{{ $t('translations.edit_my_details')}}</router-link> -->
                <!-- <router-link :to='{name: "SelectCaree"}' tag="button" class="btn btn-round btn-block btn-primary">{{ autobrand('translations.people_i_care_for') }}</router-link> -->

                <h2 v-if='!isServiceAvailable()' class="m-2 text-center">
                    <span class="icon-appointment mt-4 mb-3">
                        <svg x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"><g><path id="Shape" 
                        d="M18,12c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S14.7,12,18,12z M18,13.5c-2.5,0-4.5,2-4.5,4.5
		s2,4.5,4.5,4.5s4.5-2,4.5-4.5S20.5,13.5,18,13.5z M15,0c0.5,0,0.9,0.4,1,0.9L16,1v1h2c1.6,0,2.9,1.2,3,2.8L21,5v4
		c0,0.5-0.4,0.9-0.9,1L20,10H3v9c0,0.5,0.4,0.9,0.9,1L4,20h6c0.6,0,1,0.4,1,1c0,0.5-0.4,0.9-0.9,1L10,22H4c-1.6,0-2.9-1.2-3-2.8
		L1,19V5c0-1.6,1.2-2.9,2.8-3L4,2h2V1c0-0.6,0.4-1,1-1c0.5,0,0.9,0.4,1,0.9L8,1v1h6V1C14,0.4,14.4,0,15,0z M18,14.2
		c0.4,0,0.7,0.3,0.7,0.6l0,0.1v2.6l1.7,1.3c0.3,0.2,0.4,0.6,0.2,1L20.6,20c-0.2,0.3-0.6,0.4-1,0.2l-0.1-0.1l-2-1.5
		c-0.2-0.1-0.3-0.3-0.3-0.5l0-0.1v-3C17.2,14.6,17.6,14.2,18,14.2z M6,4H4C3.5,4,3.1,4.4,3,4.9L3,5v3h16V5c0-0.5-0.4-0.9-0.9-1L18,4
		h-2v1c0,0.5-0.4,0.9-0.9,1L15,6c-0.5,0-0.9-0.4-1-0.9L14,5V4H8v1c0,0.5-0.4,0.9-0.9,1L7,6C6.5,6,6.1,5.6,6,5.1L6,5V4z"/></g></svg>
                    </span>
                    <template v-if='$root.provider.network_service_status == 0'>
                        {{autobrand('translations.network_is_currently_unavailable_for_online_requests')}}
                    </template>
                    <template v-else>
                        {{ serviceAvailabliltyMessage() }}
                    </template>
                </h2>
            </div>
            
            <div class="card-default">
                <a v-if='!$root.embed && tBrandSetting("conf_covid_19_banner")' href="https://www.nhs.uk/conditions/coronavirus-covid-19/" class="mt-3 alert alert-covid text-center" title="NHS advice on Coronavirus (COVID-19)">{{ $t('translations.nhs_covid')}}</a>
                <router-link v-if='!$root.embed && tBrandSetting("conf_our_service_times")' :to="{name: 'serviceTimes'}" class="btn btn-round btn-outline-primary btn-block">{{ tBrandKey('our_service_times') }}</router-link>
                <router-link v-if='!$root.embed && tBrandSetting("conf_when_is_your_clinician_working")' :to="{name: 'staffAvailability'}" class="btn btn-round btn-outline-primary btn-block">{{ $t('translations.when_is_your_GP_working')}}</router-link>
            </div>
        
        </div>

        <div v-if='tBrandSetting("conf_show_licence_agreement")' class="mt-auto w-100 p-2">
            <p class="text-center"><strong><a target="_blank" href="https://askmygp.uk/about-us/askmygp-end-user-licence-agreement-eula/">{{ $t('translations.terms_of_use') }}</a></strong></p>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'returnpath',
    ],
    data: function(){
        return {
        }
    },
    mounted() {
        this.$root.selfHelpSearch = "";
        
        if(!this.$root.user) {
            this.$root.$router.push({path: "/login/Profile"});
            return;
        }
    },

    computed: {
        showServiceMessage() {
            return this.$root.showServiceMessage;
        }
    },
    
    methods: {
        
    }
}

</script>
